import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({
  searchQuery,
  onSearchChange,
  selectedTopic,
  onTopicChange,
  selectedYear,
  onYearChange,
  sortOrder,
  onSortChange,
  onClearFilters,
  totalResults,
  isExpanded,
  onToggleExpanded
}) => {
  const topicOptions = [
    { value: 'all', label: 'All Topics' },
    { value: 'funding', label: 'Funding Opportunities' },
    { value: 'research', label: 'Research Insights' },
    { value: 'policy', label: 'Policy Updates' },
    { value: 'grants', label: 'Grant Writing Tips' },
    { value: 'data', label: 'National Agency Data' }
  ];

  const yearOptions = [
    { value: 'all', label: 'All Years' },
    { value: '2025', label: '2025' },
    { value: '2024', label: '2024' },
    { value: '2023', label: '2023' },
    { value: '2022', label: '2022' }
  ];

  const sortOptions = [
    { value: 'newest', label: 'Newest First' },
    { value: 'oldest', label: 'Oldest First' },
    { value: 'relevance', label: 'Most Relevant' }
  ];

  const hasActiveFilters = searchQuery || selectedTopic !== 'all' || selectedYear !== 'all' || sortOrder !== 'newest';

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-sm">
      <div className="lg:hidden">
        <button
          onClick={onToggleExpanded}
          className="flex items-center justify-between w-full px-5 py-4 text-foreground hover:bg-muted transition-colors duration-250"
          aria-expanded={isExpanded}
          aria-label="Toggle filter panel"
        >
          <div className="flex items-center gap-2">
            <Icon name="Filter" size={20} />
            <span className="font-medium">Filters</span>
            {hasActiveFilters && (
              <span className="flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-semibold bg-accent text-accent-foreground rounded-full">
                Active
              </span>
            )}
          </div>
          <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={20} />
        </button>
      </div>
      <div className={`${isExpanded ? 'block' : 'hidden'} lg:block p-5 space-y-4`}>
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-lg font-heading font-semibold text-foreground">
            Filter Newsletters
          </h2>
          {totalResults > 0 && (
            <span className="text-sm text-muted-foreground">
              {totalResults} {totalResults === 1 ? 'result' : 'results'}
            </span>
          )}
        </div>

        <Input
          type="search"
          placeholder="Search by title, content, or tags..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-4">
          <Select
            label="Topic"
            options={topicOptions}
            value={selectedTopic}
            onChange={onTopicChange}
          />

          <Select
            label="Year"
            options={yearOptions}
            value={selectedYear}
            onChange={onYearChange}
          />

          <Select
            label="Sort By"
            options={sortOptions}
            value={sortOrder}
            onChange={onSortChange}
          />
        </div>

        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={14}
            fullWidth
          >
            Clear All Filters
          </Button>
        )}
      </div>
    </div>
  );
};

export default FilterPanel;